import { render, staticRenderFns } from "./23february.vue?vue&type=template&id=0730d930&scoped=true&"
import script from "./23february.vue?vue&type=script&lang=js&"
export * from "./23february.vue?vue&type=script&lang=js&"
import style0 from "./23february.vue?vue&type=style&index=0&id=0730d930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730d930",
  null
  
)

export default component.exports